import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

const blink = keyframes`
  from {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.span`
  display: inline-flex;
  align-items: baseline;

  .ai-loading-message {
    font-size: 14px;
    font-weight: 500;
    background: linear-gradient(
      90deg,
      ${(props) => props.theme.$gray600} 0%,
      ${(props) => props.theme.$gray600} 30%,
      #007bff 45%,
      #009f79 55%,
      ${(props) => props.theme.$gray600} 70%,
      ${(props) => props.theme.$gray600} 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${shimmer} 2.2s linear infinite, ${fadeIn} 0.35s ease-out;
  }

  /* Reticências animadas para reforçar que a espera continua. */
  .ai-loading-ellipsis span {
    color: ${(props) => props.theme.$gray600};
    animation: ${blink} 0.6s ease-in-out infinite alternate;
  }

  .ai-loading-ellipsis span:nth-child(2) {
    animation-delay: 0.2s;
  }

  .ai-loading-ellipsis span:nth-child(3) {
    animation-delay: 0.4s;
  }

  @media (prefers-reduced-motion: reduce) {
    .ai-loading-message,
    .ai-loading-ellipsis span {
      animation: none;
      -webkit-text-fill-color: ${(props) => props.theme.$gray600};
    }
  }
`;
